import React, { useState, useEffect } from 'react';
import { updateSeveralPropertiesService } from '../../../services/updateSeveralPropertiesService';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const UpdateSeveralPropertiesSaveButton = ({ closeCallback }) => {
    const { i18n } = useTranslation();
    const [dataListIsValid, setDataListIsValid] = useState(false);

    const updateSeveralProperties = () => {
        if(dataListIsValid) {
            updateSeveralPropertiesService.saveChanges();
            closeCallback(null);
        }
    };

    const changeIsValidValue = () => {
        setDataListIsValid(updateSeveralPropertiesService.areDataListsValid());
    };

    useEffect(() => {
        updateSeveralPropertiesService.registerObserverDataListsChanged(changeIsValidValue);
        return () => updateSeveralPropertiesService.unRegisterObserverDataListsChanged(changeIsValidValue);
    }, []);

    return (
        <Button className="property__button" disabled={!dataListIsValid} onClick={updateSeveralProperties}>
            {i18n.t('app.page.product.modal.updateProperties.save')}
        </Button>
    );
};

export default UpdateSeveralPropertiesSaveButton;
